export enum RouterNames {
  // ===== Public =====
  HOME = "home",
  COURSES = "courses",
  COURSE_DETAILS = "course-details",

  // ===== Auth =====
  AUTH_LOGIN = "auth-login",
  AUTH_COMPLETE_PROFILE="auth-complete-profile",
  // == Phone ==
  // AUTH_DETECT_PHONE_NUMBER = "auth-detect-phone-number",
  // AUTH_LOGIN_BY_PASSWORD = "auth-login-by-password",
  // AUTH_COMPLETED_PHONE_NUMBER_REGISTRATION_DETAILS = "auth-complete-phone-number-details",
  // AUTH_VERIFY_PHONE_NUMBER_OTP = "auth-verify-phone-number",
  // AUTH_FORGOT_PASSWORD = "auth-forgot-password",
  // AUTH_RESET_PASSWORD = "auth-reset-password",
  // AUTH_VERIFY_RESET_PASSWORD_PHONE_NUMBER_OTP = "auth-reset-password-validate-otp",
  // == Google ==
  AUTH_GOOGLE_LOGIN = "auth-google-login",

  // ===== User Area =====
  DASHBOARD_HOME = "dashboard",
  ADMIN_VIEW_USERS = "dashboard-view-users",
  STUDENT_GRADES = "dashboard-view-student-grades",
  STUDENT_PAYMENTS = "dashboard-view-student-payments",
  STUDENT_EXAMS = "dashboard-view-student-exams",
  STUDENT_EXAM = "dashboard-view-student-exam",
  STUDENT_EXAM_RESULT = "dashboard-view-student-exam-result",
  STUDENT_ATTENDANCE = "dashboard-view-student-attendance",
  ADMIN_GRADES = "dashboard-grades",
  ADMIN_EXAMS = "dashboard-exams",
  PROFILE = "profile",
  SETTINGS = "settings",
  MY_COURSES = "my-courses",
  COURSE_LESSON = "course-lesson",

  // ===== Admin =====
  ADMIN_LESSONS = "admin-create-lesson",
  ADMIN_LESSON_ATTENDANCE = "admin-lesson-attendance",
  ADMIN_DASHBOARD = "admin-dashboard",
  ADMIN_USERS = "admin-users",
  ADMIN_COURSES = "admin-courses",
  ADMIN_SETTINGS = "admin-settings",
  ADMIN_PAYMENTS = "admin-payments",
  ADMIN_GROUPS = "admin-groups",

  // ===== Errors =====
  NOT_FOUND = "not-found",
  UNAUTHORIZED = "unauthorized",
  LINK_EXPIRED = "link-expired",
}